import { useEffect, useRef, type FC } from 'react';
import { Button } from '../../components';
import { useChatTranslation } from '../hooks/use-i18n';
import { cx } from '../../cx';
import { useOpenModal } from '../../next-modal';
import { Icon } from '../../icon-svg';

export const HtmlPreview: FC<{
  html: string;
  showButton?: boolean;
  className?: string;
  btnClassName?: string;
  onClose?: () => void;
}> = (props) => {
  const { t } = useChatTranslation();
  const openModal = useOpenModal();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      const iframe = iframeRef.current;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(props.html);
        iframeDoc.close();
      }
    }
  }, [props.html, iframeRef]);

  return (
    <div className={cx('relative flex flex-col', props.className)}>
      {props.onClose && (
        <div className="flex justify-end py-2 px-4">
          <Icon
            onClick={props.onClose}
            className="animate-hover"
            boxSize="xlarge"
            size="small"
            name={'IcClose'}
          />
        </div>
      )}
      <iframe
        ref={iframeRef}
        className={cx('overflow-auto w-full h-full border-none')}
        title="HTML Preview"
        sandbox="allow-same-origin allow-scripts"
      />
      {props.showButton && (
        <Button
          className="mt-1"
          onClick={() => {
            openModal.modal({
              className: 'w-full h-full',
              containerClassName: 'px-10',
              content: ({ onCloseModal }) => {
                return (
                  <HtmlPreview html={props.html} className="w-full h-full" onClose={onCloseModal} />
                );
              },
            });
          }}
        >
          {t('open_html')}
        </Button>
      )}
    </div>
  );
};
